import { Column, Heading } from "@hex-insights/core";
import { Route, RouteSwitch, useActivePageRegistration } from "@hex-insights/router";
import { Nav } from "@hex-insights/verita-romania.shared";
import { Main } from "../../Components";
import { PreferencesIndexPage } from "./IndexPage";
import { preferencesIndexPageInfo } from "./IndexPage/pageinfo";
import { preferencesPageInfo } from "./pageinfo";
import { PreferencesStudentDataConsentsPage } from "./StudentDataConsents";
import { preferencesStudentDataConsentsPageInfo } from "./StudentDataConsents/pageinfo";

export function PreferencesPage() {
	useActivePageRegistration(preferencesPageInfo);

	return (
		<Main>
			<Heading.H1>Preferences</Heading.H1>

			<Column justify="spaced-start" style={{ maxWidth: "45rem", margin: "0 auto" }}>
				<Nav>
					<Nav.Link to={preferencesStudentDataConsentsPageInfo.to}>Data Consent</Nav.Link>
				</Nav>

				<RouteSwitch>
					<Route {...preferencesIndexPageInfo.routeProps}>
						<PreferencesIndexPage />
					</Route>
					<Route {...preferencesStudentDataConsentsPageInfo.routeProps}>
						<PreferencesStudentDataConsentsPage />
					</Route>
				</RouteSwitch>
			</Column>
		</Main>
	);
}
